import { animated, useSpring } from "@react-spring/web";
import React, { ForwardedRef, forwardRef, useEffect, useState } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

//components
import Icon from "../../../Icon/Icon";
import IconButton, { IconButtonProps } from "../../IconButton";

declare interface RotatingIconButtonProps extends IconButtonProps {
	reverseDirection?: boolean;
	isActiveOverride?: boolean;
	icon: IconDefinition;
	className?: string;
}

/**
 * @deprecated Use the ButtonIcon component from the py-components package instead
 */
const RotatingIconButton = forwardRef((props: RotatingIconButtonProps, ref: ForwardedRef<HTMLButtonElement>) => {
	const { isActiveOverride, reverseDirection, icon, onClick, ...iconButtonProps } = props;
	const [isActive, setIsActive] = useState(isActiveOverride || false);

	const springs = useSpring({
		transform: isActive ? `rotate(${reverseDirection ? "-" : ""}180deg)` : "rotate(0deg)",
	});

	useEffect(() => {
		setIsActive(!!isActiveOverride);
	}, [isActiveOverride]);

	return (
		<IconButton
			ref={ref}
			{...iconButtonProps}
			isHollow={true}
			square={true}
			onClick={() => {
				setIsActive(!isActive);
				onClick && onClick();
			}}
		>
			{
				<animated.div style={springs}>
					<Icon icon={icon} size="small" />
				</animated.div>
			}
		</IconButton>
	);
});
RotatingIconButton.displayName = "RotatingIconButton";

/** @deprecated Use the ButtonIcon component from the py-components package instead */
export default RotatingIconButton;
